module.exports = __webpack_public_path__ + "img/clinical_rotation.ad208fc3.svg";